import { render } from "./CreateContentCategoryPage.vue?vue&type=template&id=57e34a06&ts=true"
import script from "./CreateContentCategoryPage.vue?vue&type=script&lang=ts"
export * from "./CreateContentCategoryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Contents/Categories/CreateContentCategoryPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57e34a06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57e34a06', __exports__)) {
    api.reload('57e34a06', __exports__)
  }
  
  module.hot.accept("./CreateContentCategoryPage.vue?vue&type=template&id=57e34a06&ts=true", () => {
    api.rerender('57e34a06', render)
  })

}


export default __exports__